import { object, string } from 'yup';

export const documentosSchema = object({
  id: string(),
  estadoCivil: string().required('O estado civil é obrigatório'),
  cpf: string().required('O CPF é obrigatório'),
  rg: string().required('O RG é obrigatório'),
  orgEmissor: string().required('O RG é obrigatório'),
  dtEmissao: string().required('O data de expedição do RG é obrigatória'),
  uf: string().required('O estado de expedição do RG é obrigatório'),
  pis: string(),
});

export class DocumentosModel {
  id = '';

  cpf = '';

  rg = '';

  orgEmissor = '';

  dtEmissao = '';

  uf = '';

  pis = '';
}
